import { COLOR } from '../../SignupLogin/constants/style';

const Select = {
  sizes: {
    md: {
      field: {
        fontSize: '14px',
      },
    },
  },
  baseStyle: {
    field: {
      paddingRight: '12px',
      paddingLeft: '12px',
      minHeight: '44px',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '20px',
      color: '#333333',
      border: '1px solid #DDDDDD',
      webkitAppearance: 'none !important',
      mozAppearance: 'none !important',
      appearance: 'none !important',
      _focus: {
        boxShadow: 'none',
      },
    },
    icon: {
      width: '24px',
      fontSize: '20px',
    },
    _focus: {
      _invalid: {
        borderColor: COLOR.ERROR,
      },
    },
  },
  defaultProps: {
    errorBorderColor: COLOR.ERROR,
    // https://github.com/chakra-ui/chakra-ui/issues/2347#issuecomment-917375118
    variant: null,
  },
};

export default Select;
